
import Vue from 'vue';
import { CvRow, CvColumn, CvButton, CvLink } from '@carbon/vue';

export default Vue.extend({
  components: {
    CvColumn,
    CvRow,
    CvButton,
    CvLink,
  },
  props: {
    context: {
      type: String,
      required: true,
    },
    artworkId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isRemoveClicked: false,
    };
  },
  watch: {
    artworkId() {
      this.isRemoveClicked = false;
    },
  },
});
